module.exports = __webpack_public_path__ + "static/media/btn-btg.35832163.svg";